import type { TFunction } from 'i18next';

import type { PipelineGuardSimpleConditionType } from '@/gql/graphql';

export function getGuardMustBe(
  t: TFunction,
  type: PipelineGuardSimpleConditionType
): string {
  return t(`pipelineGuards.conditions.${type}.mustBe`);
}

export function getGuardMustNotBe(
  t: TFunction,
  type: PipelineGuardSimpleConditionType
): string {
  return t(`pipelineGuards.conditions.${type}.mustNotBe`);
}

export function getGuardHasBeen(
  t: TFunction,
  type: PipelineGuardSimpleConditionType
): string {
  return t(`pipelineGuards.conditions.${type}.hasBeen`);
}

export function getGuardHasNotBeen(
  t: TFunction,
  type: PipelineGuardSimpleConditionType
): string {
  return t(`pipelineGuards.conditions.${type}.hasNotBeen`);
}
